import { useCallback } from "react";
import Tooltip from "@mui/material/Tooltip";
import { DateTime } from "luxon";
import { faSpinner, faLock, faLockOpen } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useSelector } from "react-redux";
import { useTranslation } from "react-i18next";

import { TripleShift } from "../../../types/Shift";
import { RootState } from "../../../state/store";
import { useGlobalModal } from "../../Contexts/GlobalModalContext";
import ShiftLockStatusChangeModal from "./ShiftLockStatusChangeModal";

interface ShiftLockIconProps {
  selectedDate: DateTime;
  selectedShift: TripleShift;
}

export const ShiftLockIcon = (props: ShiftLockIconProps) => {
  const { t } = useTranslation();
  const {
    selectedDate,
    selectedShift
  } = props;

  const { isLocked, canToggleLock, isShiftEditibilityDataLoading, isPastAutoLockCutOff } = useSelector((state: RootState) => state.shift);
  const { showModal } = useGlobalModal();

  const handleLockClick = useCallback(async (e: React.MouseEvent) => {
    e.stopPropagation();
    if (!canToggleLock) return;

    showModal({
      content: <ShiftLockStatusChangeModal
        isCurrentlyLocked={isLocked}
        selectedDate={selectedDate}
        selectedShift={selectedShift}
      />
    });
  }, [canToggleLock, showModal, isLocked, selectedDate, selectedShift]);

  const iconColorClass = canToggleLock
    ? "cursor-pointer !text-theme-primary-contrast hover:!text-theme-primary-contrast-hover"
    : "cursor-default !text-theme-primary-contrast hover:!text-theme-primary-contrast-hover opacity-50";

  const tooltipText = isLocked
    ? canToggleLock
      ? t("crumbs.lockedCanUnlock")
      : t("crumbs.lockedCannotUnlock")
    : canToggleLock
      ? t("crumbs.unlockedCanLock")
      : t("crumbs.unlocked");

  return (
    <div className="absolute top-1/2 right-2 transform -translate-y-1/2 ">
      {isShiftEditibilityDataLoading ? (
        <span className="animate-fade-in text-theme-primary">
          <FontAwesomeIcon className="!w-5 !h-5" icon={faSpinner} spin />
        </span>
      ) : (
        isPastAutoLockCutOff ?
          <Tooltip title={tooltipText} arrow placement="top">
            <span
              onClick={handleLockClick}
              className={`${iconColorClass} transition inline-block animate-fade-in`}
            >
              <FontAwesomeIcon
                icon={isLocked ? faLock : faLockOpen}
                className="!w-5 !h-5"
              />
            </span>
          </Tooltip> :
          <span className="!w-5 !h-5"></span>
      )}
    </div>
  )
}